import { fromGid } from '@/lib/shopify/gid';
import { buildProductUrl } from '@/lib/elevar/cart-events';
import {
  getCompareAtPriceAmount,
  getElevarCurrencyCode,
  getMoneyAmount,
  getUserData,
  initElevarDataLayer,
  resolveElevarCategory,
} from '@/lib/elevar/shared';
import {
  ELEVAR_BRAND,
  ELEVAR_REFERRING_COLLECTION_KEY,
} from '@/lib/elevar/constants';

/**
 * Pushes `dl_view_item` on PDP load.
 * `list` comes from `referringCollection` set by the collection page component.
 */
export default function elevarItemView(productData, selectedVariant, pricing) {
  if (!initElevarDataLayer()) return;

  const { shopifyProduct } = productData || {};
  const variant = selectedVariant || shopifyProduct?.variants?.[0];

  if (!variant || !shopifyProduct) return;

  const storedReferrer =
    sessionStorage.getItem(ELEVAR_REFERRING_COLLECTION_KEY) || '';

  const { sale, full, hasPriceDifference } = pricing.variant(variant);

  const product = {
    id: variant?.sku || '',
    name: shopifyProduct?.title || '',
    brand: ELEVAR_BRAND,
    category: resolveElevarCategory(shopifyProduct),
    variant: variant?.title || '',
    price: getMoneyAmount(sale ?? variant?.price),
    compare_at_price: getCompareAtPriceAmount(hasPriceDifference, full, sale ?? variant?.price),
    list: storedReferrer,
    product_id: String(fromGid(shopifyProduct?.id || '')),
    variant_id: String(fromGid(variant?.id || '')),
    quantity: '1',
    url: buildProductUrl(shopifyProduct, variant),
    image: variant?.image?.url || shopifyProduct?.featuredImage?.url || '',
  };

  window.ElevarDataLayer.push({
    event: 'dl_view_item',
    user_properties: getUserData(),
    ecommerce: {
      currencyCode: getElevarCurrencyCode(variant),
      detail: {
        actionField: {
          list: storedReferrer,
          action: 'detail',
        },
        products: [product],
      },
    },
  });
}
